import * as Scrivito from "scrivito"

export const ContactDetailsObjClass = Scrivito.provideObjClass(
  "ContactDetails",
  {
    attributes: {
      title: "string",
      name: "string",
      street: "string",
      city: "string",
      zip: "string",
      county: "string",
      country: "string",
      mapsURL: "link",
      telephone: "link",
      fax: "string",
      website: "string",
      email: "link"
    }
  }
)

export type ContactDetailsObj = InstanceType<typeof ContactDetailsObjClass>
